// @flow
import React from "react"
import { Switch, Route, Redirect } from "react-router-dom"
import urls from "data/router/urls"
import LoggedInRoute from "./LoggedInRoute"
import LoggedOutRoute from "./LoggedOutRoute"

import HomePage from "pages/Home"
import ExplorePage from "pages/Explore"
import TermsPage from "pages/Terms"
import AccountPage from "pages/Account"
import ShoppingBasketPage from "pages/ShoppingBasket"
import ReservationsPage from "pages/Reservations"
import ReservationPage from "pages/Reservation"
import CheckoutPage from "pages/Checkout"
import CartPage from "pages/Cart"
import SearchPage from "pages/Search"
import ProductsPage from "pages/Products"
import ProductPage from "pages/Product"
import AffiliatePage from "pages/Affiliate"
import AffiliateRegistrationPage from "pages/AffiliateRegistration"
import NotFoundPage from "pages/NotFound"
import ResetPasswordPage from "pages/ResetPassword"
import AffiliateWelcomePage from "pages/AffiliateWelcome"
import DebugPage from "pages/Debug"

const Routes = () => (
  <Switch>
    {/* Routes for logged out AND logged in */}
    <LoggedOutRoute exact path={urls.home} component={HomePage} />
    <LoggedOutRoute path={urls.registerYourStore} component={AffiliateRegistrationPage} />
    <LoggedOutRoute path={urls.welcomeToAwayco} component={AffiliateWelcomePage} />
    <LoggedOutRoute path={urls.search} component={SearchPage} />
    <LoggedOutRoute path={urls.cart(":productVariantId", ":affiliateId")} component={CartPage} />
    <LoggedOutRoute path={urls.products} component={ProductsPage} />
    <LoggedOutRoute path={urls.explore} component={ExplorePage} />
    <LoggedOutRoute path={urls.affiliate(":id")} component={AffiliatePage} />

    {/* Routes for logged in only */}
    <LoggedInRoute path={urls.account.index} component={AccountPage} />
    <LoggedInRoute path={urls.reservations} component={ReservationsPage} />
    <LoggedInRoute path={urls.reservation(":id")} component={ReservationPage} />
    <LoggedInRoute path={urls.reserveProduct(":productVariantId", ":affiliateId")} component={CheckoutPage} />
    <LoggedInRoute path={urls.shoppingBasket} component={ShoppingBasketPage} />

    {/*
      * NOTE: "products" needs to have a lower precedence as it has a more
      * general path form than "cart" and "reserveProduct"
      */}
    <LoggedOutRoute path={urls.product(":productId", ":affiliateId")} component={ProductPage} />

    {/* Special routes that do not incur processing done by `LoggedOutRoute` */}
    <Route path={urls.brand(":name")} render={(props) => <Redirect to={`${urls.products}/?brand=${props.match.params.name}`}/>} />
    <Route path={urls.terms} component={TermsPage} />
    <Route path={urls.resetPassword} component={ResetPasswordPage} />
    <Route path={urls.debug} component={DebugPage} />

    {/* Catch all 404 */}
    <Route component={NotFoundPage} />
  </Switch>
)

export default Routes



// WEBPACK FOOTER //
// ./src/AppComponent/Content/Routes/index.js